import { cn } from './cn';

/** Spinner inline — estado pendente dentro de um texto ou botão. */
export function Spinner({ size = 15, className }: { size?: number; className?: string }) {
  return (
    <span
      role="status"
      aria-label="Carregando"
      style={{ width: size, height: size }}
      className={cn(
        'inline-block flex-none animate-spin rounded-full border-2 border-line border-t-primary',
        className,
      )}
    />
  );
}

/** Barra de progresso determinada. Use só quando o total é conhecido. */
export function Progress({
  value,
  label,
  className,
}: {
  /** 0 a 100. */
  value: number;
  label?: React.ReactNode;
  className?: string;
}) {
  const pct = Math.min(100, Math.max(0, value));
  return (
    <div className={className}>
      {label && (
        <div className="mb-1.5 flex justify-between text-xs text-fg-2">
          <span>{label}</span>
          <span className="font-mono tabular-nums">{Math.round(pct)}%</span>
        </div>
      )}
      <div
        role="progressbar"
        aria-valuenow={Math.round(pct)}
        aria-valuemin={0}
        aria-valuemax={100}
        className="h-1.5 overflow-hidden rounded-full bg-sunken"
      >
        <div className="h-full rounded-full bg-primary transition-[width]" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}

/** Esqueleto de carregamento — some assim que o dado chega. */
export function Skeleton({ className }: { className?: string }) {
  return <span className={cn('block rounded bg-sunken animate-atmos-shimmer', className)} />;
}

/** Bloco de linhas de esqueleto, com larguras irregulares. */
const SKELETON_WIDTHS = ['70%', '92%', '54%', '84%', '63%'];

export function SkeletonText({ lines = 3, className }: { lines?: number; className?: string }) {
  return (
    <div className={cn('flex flex-col gap-[7px]', className)}>
      {Array.from({ length: lines }, (_, i) => (
        <span
          key={i}
          style={{ width: SKELETON_WIDTHS[i % SKELETON_WIDTHS.length] }}
          className="block h-[11px] rounded bg-sunken animate-atmos-shimmer"
        />
      ))}
    </div>
  );
}
